import axios from 'axios'
import history from '../history'

import SetRoleUser from '../role/SetRoleUser'

const http = axios.create({
    baseURL: process.env.REACT_APP_API_BASEURL
})
// const HEADERS = {
//     'Content-Type': 'application/json'
// };

export async function postCompletarCadastro(address, contact, user, dispatch) {
    const AuthToken = 'Bearer '.concat(localStorage.getItem(process.env.REACT_APP_TOKENUSER));

    dispatch({ type: 'OPEN_LOADING' })
    await http.post('/account/addpersoncomplement',
        {
            "address": {
                "name": address.logradouro,
                "complement": address.complemento,
                "neighborhood": address.bairro,
                "cep": address.cep,
                "number": address.numero,
                "city": {
                    "code": address.ibge,
                    "state": {
                        "uf": address.uf
                    }
                }
            },
            "contact": {
                "telephone": contact.numTelefone,
                "cellphone": contact.numCelular
            }
        },
        {
            headers: {
                'Authorization': AuthToken
            }
        }).then(response => {
            successPostCompletarCadastro(response, user, dispatch);
        }).catch(erro => {
            erroPostCompletarCadastro(erro.response, dispatch);
        })
    dispatch({ type: 'CLOSE_LOADING' })
};

function successPostCompletarCadastro(response, user, dispatch) {
    localStorage.setItem(process.env.REACT_APP_TOKENUSER, response.data.token);

    const role = user.roles[0]
    SetRoleUser(dispatch, role);

    history.push('/inicial')
}

function erroPostCompletarCadastro(erro, dispatch) {
    dispatch({
        type: 'OPEN_ALERT_DIALOG',
        title: 'Completar Cadastro',
        description: 'Houve um erro ao tentar enviar os dados'
    })
}